import { Component, inject } from '@angular/core';
import { PlanPromptService } from '../../../../services/plan-prompt.service';
import { TalkToSalesService } from '../../../../services/talk-to-sales.service';

@Component({
  selector: 'app-home-final-cta',
  standalone: false,
  templateUrl: './home-final-cta.component.html',
  styleUrl: './home-final-cta.component.scss',
})
export class HomeFinalCtaComponent {
  planPrompt = inject(PlanPromptService);
  talkToSales = inject(TalkToSalesService);
}
